import BaseNewSceneCardDropdown from './base_new_scene_card_dropdown';

export default class DayTime extends BaseNewSceneCardDropdown {}
